// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#fff","menuText":"#003369","menuActiveText":"#0099da"};